import { useNavigate } from 'react-router-dom';
import { Warning, Lock, ErrorOutline, KeyboardReturn } from '@mui/icons-material';

import { GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';

import styles from './ErrorPage.module.css';

export interface Props {
  code?: number;
};

const ErrorPage = ({ code = 404 }) => {

  const navigate = useNavigate();

  const renderContent = () => {
    switch (code) {
      case 204:
        return {
          icon: <Warning style={{ fontSize: 80, color: '#ff9800' }} />,
          title: 'No hay contenido disponible',
        };
      case 403:
        return {
          icon: <Lock style={{ fontSize: 80, color: '#f44336' }} />,
          title: '403 - Acceso prohibido',
          message: 'No tienes permisos para acceder a esta página.',
        };
      case 404:
      default:
        return {
          icon: <ErrorOutline style={{ fontSize: 80, color: '#1976d2' }} />,
          title: '404 - Página no encontrada',
          message: 'La página que estás buscando no existe.',
        };
    }
  };

  const { icon, title, message } = renderContent();

  return (
    <div className={styles.container}>
      {icon}
      <h1 className={styles.h1}>{title}</h1>
      { message && <p>{message}</p> }
      { code != 204 &&
        <GlobalButton
          action={() => navigate('/', { replace: true })}
          variant={GlobalButtonVariant.primaryButton}>
          <KeyboardReturn />
          Volver al inicio
        </GlobalButton>
      }
    </div>
  );
}

export default ErrorPage;
